import Utils from "../utils/utilities"
import OnEvent from "../decorators/on-event"
import { getSingletonInstance } from "../services/singleton-cache"
import ListEntrance from "./list-entrance"
import { WINDOW } from "../utils/window-utils"

const SHOW: string = 'show'
const REMOVE_STRING: string = 'REMOVED'
const RENAME_STRING: string = 'RENAMED'
const ADDED_STRING: string = 'ADDED'
const DEFAULT_UPDATE_MESSAGE: string = 'This list has been updated on another device'
const UPDATE_SUBSCRIPTION_CONTENT: any = {
    REMOVED: 'An item has been removed from this list on another device',
    RENAMED: 'This list has been renamed on another device',
    ADDED: 'An item has been added to this list on another device'
}

const showHideToast: Function = (show: boolean): void => {
    const toast: HTMLElement = document.querySelector('[toast]')
    if (show) toast.classList.add(SHOW)
    else toast.classList.remove(SHOW)
}
const updateSubscriptionContent: Function = (type: string) => {
    const typeContent: string = UPDATE_SUBSCRIPTION_CONTENT[type]
    const toastContentArea: HTMLElement = document.querySelector('[toast-content]')

    if (Utils.isDefined(typeContent)) toastContentArea.innerText = typeContent
    else toastContentArea.innerText = DEFAULT_UPDATE_MESSAGE
}

export default class UpdateSubscription {

    private webSocket: WebSocket

    private onOpen(subscription: string): void {
        this.webSocket.send(subscription)
    }

    private onMessage(message: MessageEvent): void {
        const messageData: any = JSON.parse(message.data)

        if (Utils.isDefined(messageData.type) &&
            (messageData.type === ADDED_STRING ||
            (messageData.type === RENAME_STRING && !WINDOW.nativeWindow.renaming) ||
            (messageData.type === REMOVE_STRING && !WINDOW.nativeWindow.removing))) {
            updateSubscriptionContent(messageData.type)
            showHideToast(true)
            WINDOW.nativeWindow.renaming = false
            WINDOW.nativeWindow.removing = false
        }
    }

    public subscribeToWebSocket(url: string, subscription: string): void {
        const timeout: Function = () => {
            this.webSocket = new WebSocket(url)
            this.webSocket.onopen = () => this.onOpen(subscription)
            this.webSocket.onmessage = this.onMessage
        }

        setTimeout(timeout)
    }

    @OnEvent({
        selector: '[refresh-list]'
    })
    private refreshList(): void {
        getSingletonInstance(new ListEntrance()).init()
        showHideToast(false)
    }

    @OnEvent({
        selector: '[dismiss-toast]'
    })
    private cancelToast(): void {
        showHideToast(false)
    }
}